<script setup lang="ts">
import { onBeforeMount } from "vue";

import { useTailwindToggle } from "@/use/use-tailwind-toggle";

const { tailwindSupported, tailwindEnabled, tailwindLocked, toggleTailwind } =
  useTailwindToggle();

const handleToggleTailwindClick = async (event: Event) => {
  const value = (event.target as HTMLInputElement).checked;

  await toggleTailwind(value);
};

onBeforeMount(async () => {
  if (import.meta.env.VITE_TAILWIND_ENABLED) {
    await toggleTailwind(true);
  }
});
</script>

<template>
  <div class="tailwind-toggle">
    <input
      id="tailwind"
      v-model="tailwindEnabled"
      type="checkbox"
      class="tw:form-checkbox tailwind-checkbox"
      :value="tailwindEnabled"
      :disabled="tailwindLocked"
      @input="handleToggleTailwindClick"
    />
    <label for="tailwind">Enable Tailwind</label>

    <div v-if="tailwindLocked" class="reset-message">
      <template v-if="tailwindSupported">(refresh to reset)</template>
      <template v-else>(not supported)</template>
    </div>
  </div>
</template>

<style>
.tailwind-toggle {
  display: grid;
  grid-template-columns: repeat(2, auto);
  column-gap: 0.5em;
  align-items: center;
  justify-content: start;

  .tailwind-checkbox:disabled {
    color: GrayText;
    outline-color: GrayText;
  }

  .tailwind-checkbox:disabled ~ * {
    color: GrayText;
  }

  .reset-message {
    grid-column-end: -1;
    /* @apply tw:text-sm; */
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
</style>
